// Standard guided VHC walkaround steps shown to the technician while recording.
// These keep every workshop video consistent — same flow, same camera angles,
// same talking points. Item-specific steps (from VHC import) get appended after.

export const STANDARD_CHAPTERS = [
  { id: "intro", label: "Vehicle & registration", hint: "Plate, mileage, and overall condition. Greet the customer." },
  { id: "front", label: "Front exterior", hint: "Walk around the front — bumper, lights, bonnet shut, glass." },
  { id: "front-wheels", label: "Front wheels & tyres", hint: "Tread depth, sidewall damage, alloy condition." },
  { id: "brakes-susp", label: "Brakes & suspension", hint: "Show pad thickness, disc surface, shock condition." },
  { id: "engine-bay", label: "Engine bay", hint: "Fluids, belts, hoses, leaks, battery condition." },
  { id: "underside", label: "Underside", hint: "Exhaust, sump, gearbox, fuel lines, any leaks." },
  { id: "rear", label: "Rear & boot", hint: "Rear bumper, exhaust tailpipe, boot floor, spare wheel." },
  { id: "interior", label: "Interior & dashboard", hint: "Warning lights, controls, seatbelts, condition." },
];

export const SUMMARY_CHAPTER = {
  id: "summary",
  label: "Summary & sign-off",
  hint: "Recap the findings — green / amber / red — and thank the customer.",
};

// Build the full chapter list for a job: standard steps + one focused step
// per Amber/Red item, then a summary step.
export function buildChapters(items = []) {
  const itemSteps = (items || [])
    .filter((i) => i.urgency === "red" || i.urgency === "amber")
    .map((i) => ({
      id: `item-${i.id}`,
      label: i.name,
      hint: i.description ? `Close-up: ${i.description}` : `Close-up of the ${i.urgency.toUpperCase()} item.`,
      urgency: i.urgency,
      itemId: i.id,
    }));
  return [...STANDARD_CHAPTERS, ...itemSteps, SUMMARY_CHAPTER];
}
